function CommsPageSubmenu({ renderItems, translate }) {
  return renderItems([
    { label: translate('items'), link: 'faq' },
    { label: translate('feedbacks', 'comm'), link: 'feedbacks' },
  ]);
}

export default CommsPageSubmenu;
